import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, NavigationEnd } from '@angular/router';
import { AppService } from '../shared/service/app.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { toggleAnimation } from 'src/app/shared/animations';
import Keycloak from 'keycloak-js';
import { inject } from '@angular/core';
import { catchError, forkJoin, of } from 'rxjs';

import { SharedModule } from 'src/shared.module';
import { NgClass } from '@angular/common';
import { MeService } from 'src/app/shared/service/user/me.service';
import { MethodModel } from 'src/app/shared/models/method.model';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'header',
    templateUrl: './header.html',
    animations: [toggleAnimation],
    standalone: true,
    imports: [SharedModule, NgClass]
})
export class HeaderComponent implements OnInit {
    store: any;
    search = false;
    userInitials = 'U';
    userName = 'User';
    userEmail = '';
    logoPath = environment.logoPath;

    private readonly kc: Keycloak = inject(Keycloak);
    private readonly meService: MeService = inject(MeService);
    private readonly translate: TranslateService = inject(TranslateService);
    private readonly router: Router = inject(Router);
    private readonly appSetting: AppService = inject(AppService);
    private readonly sanitizer: DomSanitizer = inject(DomSanitizer);
    public readonly storeData: Store<any> = inject(Store<any>);

    notifications = [
        {
            id: 1,
            profile: 'user-profile.jpeg',
            message: '<strong class="text-sm mr-1">John Doe</strong>invite you to <strong>Prototyping</strong>',
            time: '45 min ago',
        },
        {
            id: 2,
            profile: 'profile-34.jpeg',
            message: '<strong class="text-sm mr-1">Adam Nolan</strong>mentioned you to <strong>UX Basics</strong>',
            time: '9h Ago',
        },
        {
            id: 3,
            profile: 'profile-16.jpeg',
            message: '<strong class="text-sm mr-1">Anna Morgan</strong>Upload a file',
            time: '9h Ago',
        },
    ];
    methods: MethodModel[] = [];
    currentMethodId: string | null = null;
    currentMethodLabel = '...';
    messages = [
        {
            id: 1,
            image: this.sanitizer.bypassSecurityTrustHtml(
                `<span class="grid place-content-center w-9 h-9 rounded-full bg-success-light dark:bg-success text-success dark:text-success-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg></span>`,
            ),
            title: 'Congratulations!',
            message: 'Your OS has been updated.',
            time: '1hr',
        },
        {
            id: 2,
            image: this.sanitizer.bypassSecurityTrustHtml(
                `<span class="grid place-content-center w-9 h-9 rounded-full bg-info-light dark:bg-info text-info dark:text-info-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg></span>`,
            ),
            title: 'Did you know?',
            message: 'You can switch between artboards.',
            time: '2hr',
        },
        {
            id: 3,
            image: this.sanitizer.bypassSecurityTrustHtml(
                `<span class="grid place-content-center w-9 h-9 rounded-full bg-danger-light dark:bg-danger text-danger dark:text-danger-light"> <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></span>`,
            ),
            title: 'Something went wrong!',
            message: 'Send Reposrt',
            time: '2days',
        },
        {
            id: 4,
            image: this.sanitizer.bypassSecurityTrustHtml(
                `<span class="grid place-content-center w-9 h-9 rounded-full bg-warning-light dark:bg-warning text-warning dark:text-warning-light"><svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">    <circle cx="12" cy="12" r="10"></circle>    <line x1="12" y1="8" x2="12" y2="12"></line>    <line x1="12" y1="16" x2="12.01" y2="16"></line></svg></span>`,
            ),
            title: 'Warning',
            message: 'Your password strength is low.',
            time: '5days',
        },
    ];

    ngOnInit() {
        this.initStore();
        this.loadUserInfo();
        this.loadMethods();
        this.setActiveDropdown();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.setActiveDropdown();
            }
        });
    }

    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    setActiveDropdown() {
        const selector = document.querySelector('ul.horizontal-menu a[routerLink="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const all: any = document.querySelectorAll('ul.horizontal-menu .nav-link.active');
            for (let i = 0; i < all.length; i++) {
                all[0]?.classList.remove('active');
            }
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele?.classList.add('active');
                    });
                }
            }
        }
    }

    removeNotification(value: number) {
        this.notifications = this.notifications.filter((d) => d.id !== value);
    }

    removeMessage(value: number) {
        this.messages = this.messages.filter((d) => d.id !== value);
    }

    changeLanguage(item: any) {
        this.translate.use(item.code);
        this.appSetting.toggleLanguage(item);
        if (this.store.locale?.toLowerCase() === 'ae') {
            this.storeData.dispatch({ type: 'toggleRTL', payload: 'rtl' });
        } else {
            this.storeData.dispatch({ type: 'toggleRTL', payload: 'ltr' });
        }
        window.location.reload();
    }

    private loadMethods(): void {
        forkJoin({
            methods: this.meService.getMyMethods().pipe(catchError(() => of([] as MethodModel[]))),
            me: this.meService.me().pipe(catchError(() => of(null))),
        }).subscribe(({ methods, me }) => {
            this.methods = (methods ?? []).slice().sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
            this.selectMethod(me!.currentMethod!);
        });
    }

    selectMethod(method: MethodModel): void {
        this.meService.setCurrentMethod(method).subscribe((selected: MethodModel) => {
            const resolved = selected ?? method;
            this.currentMethodId = resolved?.id ?? null;
            this.currentMethodLabel = resolved?.name?.trim() || resolved?.id || '...';
            this.reloadCurrentRoute();
        });
    }

    private loadUserInfo(): void {
        const token = this.kc.tokenParsed as Record<string, any> | undefined;
        const fullName = this.resolveUserName(token);
        const email = typeof token?.['email'] === 'string' ? token?.['email'] : '';
        const preferredUsername = typeof token?.['preferred_username'] === 'string' ? token?.['preferred_username'] : '';

        this.userName = fullName || preferredUsername || 'User';
        this.userEmail = email;
        this.userInitials = this.buildInitials(this.userName || this.userEmail || preferredUsername || 'User');
    }

    private resolveUserName(token?: Record<string, any>): string {
        if (!token) {
            return '';
        }
        const name = typeof token['name'] === 'string' ? token['name'] : '';
        if (name) {
            return name;
        }
        const givenName = typeof token['given_name'] === 'string' ? token['given_name'] : '';
        const familyName = typeof token['family_name'] === 'string' ? token['family_name'] : '';
        return [givenName, familyName].filter(Boolean).join(' ');
    }

    private buildInitials(value: string): string {
        const cleaned = value.replace(/[^A-Za-z0-9 ]+/g, ' ').trim();
        if (!cleaned) {
            return 'U';
        }
        const parts = cleaned.split(/\s+/).filter(Boolean);
        if (parts.length === 1) {
            return parts[0].slice(0, 2).toUpperCase();
        }
        const first = parts[0][0] ?? '';
        const last = parts[parts.length - 1][0] ?? '';
        return `${first}${last}`.toUpperCase() || 'U';
    }

    async signOut(): Promise<void> {
        await this.kc.logout({ redirectUri: window.location.origin });
    }

    private reloadCurrentRoute(): void {
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigateByUrl(currentUrl);
        });
    }
}
